import { lazy, Suspense } from 'react'
import PropTypes from 'prop-types'

import { ConnectedRouter } from 'connected-react-router/immutable'
import { Route, Switch } from 'react-router-dom'

import RouteEnum from '@constants/RouteEnum'
import GlobalStyle from '@assets/global-style/global-style'

import Default from './default-plan/default-plan'
import StepCompany from './company-step/company-step'
import StepLegalResponsible from './legal-responsible-step/legal-responsible-step'
import StepAddress from './address-step/address-step'
import StepSecurity from './security-step/security-step'
import StepSuccess from './success-step/success-step'

const App = ({ history }) => {
  return (
    <ConnectedRouter history={history}>
      <GlobalStyle />
      <Suspense fallback={() => <h1>carregando</h1>}>
        <Switch>
          <Route exact path={RouteEnum.DefaultPlan} component={Default} />
          <Route exact path={RouteEnum.CompanyStep} component={StepCompany} />
          <Route path={RouteEnum.LegalResponsibleStep} component={StepLegalResponsible} />
          <Route path={RouteEnum.AddressStep} component={StepAddress} />
          <Route path={RouteEnum.SecurityStep} component={StepSecurity} />
          <Route path={RouteEnum.SuccessStep} component={StepSuccess} />
          <Route component={Default} />
        </Switch>
      </Suspense>
    </ConnectedRouter>
  )
}

App.propTypes = {
  history: PropTypes.object.isRequired,
}

export default App
